module.exports = __webpack_public_path__ + "static/media/notFoundMap.6b6a0105.png";